import { subscribeQuote, unsubscribeQuote } from './quoteActions';
import { fetchTheScreenerDetails } from './screenerActions';
import { fetchMorningstarDetails } from './morningstarActions';
import { fetchFxRates, subscribeFxRates, unsubscribeFxRates, setFxRateUseWs } from './fxRateActions';
import { actions } from './store';
import { setQuotesUseWs } from './wsActions';

export const marketdataActions = {
  subscribeQuote,
  unsubscribeQuote,
  fetchTheScreenerDetails,
  fetchMorningstarDetails,
  fetchFxRates,
  subscribeFxRates,
  unsubscribeFxRates,
  quoteFetched: actions.quoteFetched,
  fxRatesFetched: actions.fxRatesFetched,
  setFxRateUseWs,
  setQuotesUseWs
};
export { createMarketDataStore, defaultMarketDataStore, MARKET_DATA_STORE_NAME } from './store';
export * from './hooks';
export * from './types';
